<app-carrousel-gov-co class="md:block hidden "/>
<div class="width-container">
  <div class="flex justify-content-between align-items-center flex-wrap ">
    <header class="lg:mt-0 sm:mt-2">
      <h1 class="title-blue animated-text font-23 font-roboto-condensed text-uppercase font-normal my-4 sm:my-0">
        {{ 'components.app-sede-electronica-pqrsdf.title' | translate }}
      </h1>
      <h5 class="app-text-gray font-principal font-15 font-normal hidden sm:block my-0 animated-text">
        {{ 'components.app-sede-electronica-pqrsdf.subtitle' | translate }}
      </h5>
      <span class="app-text-gray font-principal font-15 font-normal animated-text sm:hidden block my-2">
        {{ 'components.app-sede-electronica-pqrsdf.subtitle-movil' | translate }}:
      </span>
    </header>
    <div class="lg:mt-0 sm:mt-2 border-gradient container-input-rounded content-border p-0 search-input custom-placeholder-container">
      <div class="container-icon border-circle bg-gray-200">
        <i class="pi pi-hashtag title-blue"></i>
      </div>
      <div class="input-wrapper">
        <div class="custom-placeholder" [class.hidden]="searchProcedure && searchProcedure.length > 0">
          <span class="font-medium">{{ placeholderSearch()?.bold }}</span>
          <span class="font-normal">{{ placeholderSearch()?.normal }}</span>
        </div>
        <input pInputText placeholder=""  (keydown.enter)="searchRadicado()"
               [(ngModel)]="searchProcedure"
               class="border-0 app-text-gray input-text font-principal font-16 custom-input">
      </div>
      <button pButton (click)="searchRadicado()"
              class="p-button-rounded btn-blue-general flex
                      align-items-center justify-content-center">
        <span class="text-white font-16 font-medium animated-text">
          {{ 'form.button.ver' | translate }}
        </span>
        <img ngSrc="assets/img/svg/gov-ico-search.svg" alt="icon search"
             priority draggable="false" width="20" height="19"/>
      </button>
    </div>
    <h5 class="app-text-gray font-principal font-15 font-normal mt-5 mb-0 block sm:hidden animated-text">
      {{ 'components.app-sede-electronica-pqrsdf.subtitle' | translate }}
    </h5>
  </div>
  <main class="mt-5 pqr-container">
    @for (item of cards; track $index) {
      <p-card class="pqr-card active-border-gradient" [routerLink]="item.link">
        <div class="pqr-card-header">
          <img [ngSrc]="item.img.src"
               [alt]="item.img.alt" width="24" height="24"
               priority draggable="false">
          <div class="title-blue hidden sm:block animated-text" [innerHTML]="item.titleHtml | safeResource: 'html'"></div>
        </div>
        <div class="pqr-card-content">
          <div class="text-blue-general
           sm:hidden block animated-text" [innerHTML]="item.titleHtml | safeResource: 'html'"></div>

          <p class="app-text-gray font-normal font-13 mt-0 sm:mt-1 mb-0">
            {{ item.description }}
          </p>
        </div>
        <div class="block sm:hidden pqr-card-footer">
          <button pButton class="pqr-card-button px-0">
            <i class="pi pi-angle-right text-blue-general "></i>
          </button>
        </div>
      </p-card>
    }
  </main>
</div>
